/* eslint-disable react-hooks/exhaustive-deps */
import { get, isEmpty } from "lodash";
import { isArray } from "lodash-es";
import React, { useEffect, useState } from "react";
import { getIndustryCodes, getTaxOfficeCodes } from "../../../apis/code";
import {
  CardTitle,
  ColCard,
  Row,
  Col,
} from "../../../components/ContentLayout";
import DataComponent from "../../../components/DataComponent";
import { dateToFormat } from "../../../utils/date";


const BasicInfo = (props) => {
  const {
    form,
    setForm,
    handleOnChange,
    handleSubmit,
    errors,
    setValidateFields,
    mode = "detail",
  } = props;
  const [requiredFields, setRequiredFields] = useState({});
  const [optionalFields, setOptionalFields] = useState({});
  const [industryCodes, setIndustryCodes] = useState([]);
  const [taxOfficeCodes, setTaxOfficeCodes] = useState([]);

  useEffect(() => {
    setValidateFields([
      { key: "comNum", type: 'input', required: true, validators: ['comNum'] },
      { key: "rgeNum", type: 'input', required: false, validators: ['jumin'] },
    ]);

    getIndustryCodes().then((res) => {
      res = res.data.industryCodes.map((industry) => ({
        label: `${industry.type} > ${industry.sect} [${industry.code}]`,
        value: industry.stCode,
        industry,
      }));

      setIndustryCodes(res);
    });

    getTaxOfficeCodes().then((res) => {
      res = res.data.taxOfficeCodes.map((office) => ({
        label: `${office.name} - ${office.addr}`,
        value: office.code,
        office,
      }));

      setTaxOfficeCodes(res);
    });
  }, []);

  useEffect(() => {
    setRequiredFields({
      left: [
        {
          title: "회사명",
          key: "name",
          type: "input",
          className: "manager-form-input",
          options: { disabled: mode === "detail" },
        },
        {
          title: "대표자",
          key: "ceoName",
          type: "input",
          className: "manager-form-input",
          options: { disabled: mode === "detail" },
        },
        {
          title: "사업자등록번호",
          key: "comNum",
          type: "input",
          className: "manager-form-input",
          options: { disabled: mode === "detail" },
        },
      ],
      right: [
        {
          title: "사업형태",
          key: "sep",
          type: "radio",
          className: "manager-form-radio",
          options: {
            list: [
              { label: "법인사업자", value: "0" },
              { label: "개인사업자", value: "1" },
            ],
            disabled: mode === "detail",
          },
        },
        {
          title: "법인 등록번호",
          key: "rgeNum",
          type: "input",
          className: "manager-form-input",
          options: { disabled: mode === "detail" },
        },
        {
          title: "과세 유형",
          key: "incomType",
          type: "radio",
          className: "manager-form-radio",
          options: {
            list: [
              { label: "일반과세", value: "1" },
              { label: "면세", value: "2" },
              { label: "겸영", value: "3" },
            ],
            disabled: mode === "detail",
          },
        },
        {
          title: "종사업장번호",
          key: "sectNum",
          type: "input",
          className: "manager-form-input",
          options: { disabled: mode === "detail" },
        },
      ],
    });

  }, [mode]);


  useEffect(() => {
    // TODO 쫌 그럼
    if (!isEmpty(industryCodes) && !isEmpty(taxOfficeCodes)) {
      setOptionalFields({
        left: [
          {
            title: "개업년월",
            key: "openDate",
            type: "datepicker",
            className: "manager-form-datepicker",
            options: {
              disabled: mode === "detail",
            },
            onChange: (date) => {
              setForm({ ...form, openDate: dateToFormat(date[0] || date.openDate[0]) });
            },
          },
          {
            title: "주소",
            key: "address",
            type: "address",
            className: "manager-form-address",
            zipCodeClassName: "manager-form-input zipCode",
            buttonClassName: "margin-left-8",
            addrClassName: "manager-form-input margin-top-8",
            detailAddrClassName: "manager-form-input margin-top-8",
            options: {
              disabled: mode === "detail",
            },
          },
          {
            title: "업종",
            key: "bsnCode",
            type: "search-select",
            className: "manager-form-search-select",
            defaultValue: industryCodes.filter(
              (opt) => opt.value === get(form, "bsnCode")
            ),
            options: {
              list: industryCodes,
              disabled: mode === "detail",
              menuPlacement: "top",
              placeholder: "업종/업종코드 검색 (업종코드 예:[741203])",
            },
            onChange: (data) => {
              setForm({
                ...form,
                bsnType: data.industry.type,
                bsnCode: data.industry.code,
                bsnSect: data.industry.sect,
              });
            },
          },
        ],
        right: [
          {
            title: "사업장 전화번호",
            key: "phone",
            type: "input",
            className: "manager-form-input",
            options: { disabled: mode === "detail" },
          },
          {
            title: "사업장 팩스번호",
            key: "fax",
            type: "input",
            className: "manager-form-input",
            options: { disabled: mode === "detail" },
          },
          {
            title: "세금계산서 발행",
            key: "taxEmail",
            type: "input",

            className: "manager-form-input",
            options: {
              disabled: mode === "detail",
              placeholder: "대표 이메일을 입력해주세요",
            },
          },
          {
            title: "사업장세무서",
            key: "taxCode",
            type: "search-select",
            className: "manager-form-search-select",
            defaultValue: taxOfficeCodes.filter(
              (opt) => opt.value === get(form, "taxCode")
            ),
            options: {
              list: taxOfficeCodes,
              disabled: mode === "detail",
              menuPlacement: "top",
            },
            onChange: (data) => {
              setForm({
                ...form,
                taxCode: data.office.code,
                taxAccount: data.office.account,
                taxName: data.office.name,
              });
            },
          },
        ],
      });
    }
  }, [mode, industryCodes, taxOfficeCodes, form]);

  return (
    <div className="BasicInfo">
      <form onSubmit={handleSubmit}>
        <ColCard size="lg">
          <CardTitle className="color-gray-7">필수 정보</CardTitle>
          <Row className="form-row">
            <Col className="form-col" sm={6}>
              <div className="left">
                {isArray(requiredFields && requiredFields.left) &&
                  requiredFields.left.map((field, idx) => (
                    <div className="form-item" key={idx}>
                      <label className="form-label">{field.title}</label>
                      <div className="form-component-wrap">
                        <DataComponent
                          field={field}
                          form={form}
                          onChange={handleOnChange}
                          className={field.className}
                        />
                        {errors && errors[field.key] && (
                          <div className="message">
                            <p className="error-message">{errors[field.key]}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </Col>
            <Col sm={6} className="form-col">
              <div className="right">
                {isArray(requiredFields && requiredFields.right) &&
                  requiredFields.right.map((field, idx) => (
                    <div className="form-item" key={idx}>
                      <label className="form-label">{field.title}</label>
                      <div className="form-component-wrap">
                        <DataComponent
                          field={field}
                          className={field.className}
                          form={form}
                          onChange={handleOnChange}
                        />
                        {errors && errors[field.key] && (
                          <div className="message">
                            <p className="error-message">{errors[field.key]}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </Col>
          </Row>
          <CardTitle className="color-gray-7 margin-top-88">
            부가 정보
          </CardTitle>
          <Row className="form-row">
            <Col sm={6} className="form-col">
              <div className="left">
                {isArray(optionalFields && optionalFields.left) &&
                  optionalFields.left.map((field, idx) => (
                    <div className="form-item" key={idx}>
                      <label className="form-label">{field.title}</label>
                      <div className="form-component-wrap">
                        <DataComponent
                          field={field}
                          className={field.className}
                          form={form}
                          setForm={setForm}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>
                  ))}
                <div className="industry-info-wrap">

                  <div className="industry-wrap">
                    <label className="sub-label">업종코드</label>
                    <span className="form-value">{get(form, "bsnCode")}</span>
                  </div>
                  <div className="industry-wrap">
                    <label className="sub-label">업태</label>
                    <span className="form-value">
                      <DataComponent
                        field={{
                          title: "업태",
                          key: "bsnType",
                          type: "input",
                          options: { disabled: mode === "detail" },
                        }}
                        form={form}
                        setForm={setForm}
                        onChange={handleOnChange}
                      />
                      {/* {get(form, "bsnType")} */}
                    </span>
                  </div>
                  <div className="industry-wrap">
                    <label className="sub-label">업종</label>

                    <span className="form-value">
                      <DataComponent
                        field={{
                          title: "업종",
                          key: "bsnSect",
                          type: "input",
                          options: { disabled: mode === "detail" },
                        }}
                        form={form}
                        setForm={setForm}
                        onChange={handleOnChange}
                      />
                      {/* {get(form, "bsnSect")} */}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col sm={6} className="form-col">
              <div className="right">
                {isArray(optionalFields && optionalFields.right) &&
                  optionalFields.right.map((field, idx) => (
                    <div className="form-item" key={idx}>
                      <label className="form-label">{field.title}</label>
                      <div className="form-component-wrap">
                        <DataComponent
                          field={field}
                          className={field.className}
                          form={form}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>
                  ))}
                <div className="tax-office-info-wrap">
                  <div className="tax-office-wrap">
                    <label className="sub-label">코드</label>
                    <span className="form-value">{get(form, "taxCode")}</span>
                  </div>
                  <div className="tax-office-wrap">
                    <label className="sub-label">지방세 법정코드</label>
                    <span className="form-value">
                      {get(form, "taxAccount")}
                    </span>
                  </div>
                  <div className="tax-office-wrap">
                    <label className="sub-label">세무서</label>
                    <span className="form-value">{get(form, "taxName")}</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </ColCard>
      </form>
    </div>
  );
};

export default BasicInfo;

// "idx": 0,
// "type": 0, 회사타입
// "name": "string", 회사명
// "sep": 0, 법인구분
// "ceoName": "string", 대표명
// "comNum": "string", 사업자번호
// "sectNum": "string", 종사업자번호
// "incomType": 1, 과세구분
// "rgeNum": "string", 법인등록번호 / 주민등록번호
// "zipCode": "string", 우편번호
// "address": "string", 주소
// "addressDetail": "string", 상세주소
// "phone": "string", 사업장 전화번호
// "fax": "string", 팩스번호
// "bsnCode": "string", 업종코드
// "bsnType": "string", 업태
// "bsnSect": "string", 업종정보
// "taxCode": "string", 세무코드
// "taxName": "string", 세무서 이름
// "taxAccount": "string", 지방세법정코드
// "openDate": "string", 개업년월
// "taxEmail": "string" 세금발행이메일
